import { EBrandingLevel } from 'shared/types/offerData';

import { IState } from '../../store';

export const selectBrandingLevel = (state: IState): EBrandingLevel | null => {
  return state.offerData.brandingLevel || null;
};
